'use strict';

angular.module('app.rankingScoreReportInformation', [])
    .directive('rankingScoreReportInformationDirective', function () {
        return {
            controller: 'rankingScoreReportInformationCtrl',
            templateUrl: 'app/measure/rankingScoreReport/rankingScoreReportInformation/rankingScoreReportInformation.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })